
import React from 'react';
import { Heart, Coffee } from 'lucide-react';
import { useWebsiteSettings } from '@/hooks/useWebsiteSettings';

interface SupportButtonsProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'minimal';
}

const SupportButtons: React.FC<SupportButtonsProps> = ({ 
  className = '', 
  size = 'md',
  variant = 'default'
}) => {
  const { settings, isLoading } = useWebsiteSettings();

  if (isLoading) {
    return null;
  }

  if (!settings?.donate_url && !settings?.coffee_url) {
    return null;
  }

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      {settings?.donate_url && (
        <a
          href={settings.donate_url}
          target="_blank"
          rel="noopener noreferrer"
          className={`
            inline-flex items-center ${sizeClasses[size]} 
            bg-[#0070f3] hover:bg-[#0051cc] 
            text-white font-medium rounded-lg 
            transition-all duration-300 
            hover:scale-105 hover:shadow-lg hover:shadow-blue-500/25
            border border-transparent
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900
          `}
        >
          <Heart className={`${iconSizes[size]} mr-2`} />
          {settings?.donate_text || 'Support Us'}
        </a>
      )}
      {settings?.coffee_url && (
        <a
          href={settings.coffee_url}
          target="_blank"
          rel="noopener noreferrer"
          className={`
            inline-flex items-center ${sizeClasses[size]} 
            bg-[#FFDD44] hover:bg-[#FFD700] 
            text-black font-bold rounded-lg 
            transition-all duration-300 
            hover:scale-105 hover:shadow-lg hover:shadow-yellow-500/25
            border border-transparent
            focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 focus:ring-offset-gray-900
          `}
        >
          <Coffee className={`${iconSizes[size]} mr-2`} />
          {settings?.coffee_text || 'Buy Me a Coffee'}
        </a>
      )}
    </div>
  );
};

export default SupportButtons;
